import React from 'react';

// Componentes SVG de bandeiras para garantir compatibilidade total
export const BrazilFlag = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" fill="#009B3A" rx="8"/>
    <path d="M32 8 L56 32 L32 56 L8 32 Z" fill="#FEDF00"/>
    <circle cx="32" cy="32" r="10" fill="#002776"/>
    <path d="M25 32 Q32 28 39 32" stroke="white" strokeWidth="2" fill="none"/>
  </svg>
);

export const USAFlag = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" fill="#B22234" rx="8"/>
    <rect width="64" height="5" y="5" fill="white"/>
    <rect width="64" height="5" y="14" fill="white"/>
    <rect width="64" height="5" y="23" fill="white"/>
    <rect width="64" height="5" y="32" fill="white"/>
    <rect width="64" height="5" y="41" fill="white"/>
    <rect width="64" height="5" y="50" fill="white"/>
    <rect width="26" height="28" fill="#3C3B6E" rx="4"/>
    <g fill="white">
      <circle cx="8" cy="8" r="1.5"/>
      <circle cx="14" cy="8" r="1.5"/>
      <circle cx="20" cy="8" r="1.5"/>
      <circle cx="8" cy="14" r="1.5"/>
      <circle cx="14" cy="14" r="1.5"/>
      <circle cx="20" cy="14" r="1.5"/>
      <circle cx="8" cy="20" r="1.5"/>
      <circle cx="14" cy="20" r="1.5"/>
      <circle cx="20" cy="20" r="1.5"/>
    </g>
  </svg>
);

export const EUFlag = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" fill="#003399" rx="8"/>
    <g fill="#FFCC00">
      <circle cx="32" cy="12" r="2"/>
      <circle cx="44" cy="16" r="2"/>
      <circle cx="50" cy="26" r="2"/>
      <circle cx="50" cy="38" r="2"/>
      <circle cx="44" cy="48" r="2"/>
      <circle cx="32" cy="52" r="2"/>
      <circle cx="20" cy="48" r="2"/>
      <circle cx="14" cy="38" r="2"/>
      <circle cx="14" cy="26" r="2"/>
      <circle cx="20" cy="16" r="2"/>
    </g>
  </svg>
);

export const UKFlag = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" fill="#012169" rx="8"/>
    <path d="M0 0 L64 64 M64 0 L0 64" stroke="white" strokeWidth="10"/>
    <path d="M0 0 L64 64 M64 0 L0 64" stroke="#C8102E" strokeWidth="6"/>
    <path d="M32 0 L32 64 M0 32 L64 32" stroke="white" strokeWidth="14"/>
    <path d="M32 0 L32 64 M0 32 L64 32" stroke="#C8102E" strokeWidth="8"/>
  </svg>
);

export default { BrazilFlag, USAFlag, EUFlag, UKFlag };
